import type { User } from '@/api/common/auth';
import { FullStory, init, isInitialized } from '@fullstory/browser';

export function initFullStory(): void {
  if (isInitialized()) return;

  if (import.meta.env.VITE_FULLSTORY_ENABLED !== 'true') {
    console.warn('[FullStory] Disabled — set VITE_FULLSTORY_ENABLED=true in .env to enable');
    return;
  }

  init({
    orgId: 'o-330E-eu1',
    host: 'eu1.fullstory.com',
    script: 'edge.eu1.fullstory.com/s/fs.js'
  });
}

export function identifyUser(user: User): void {
  if (!isInitialized()) return;

  const userId = user.Id || user.Email;
  if (userId === '') return;

  const displayName = `${user.FirstName} ${user.LastName}`.trim() || user.Name;
  const primaryCompany = user.Companies[0];
  const primaryRole = user.Roles[0];

  const userProperties = {
    displayName: displayName,
    email: user.Email,

    userId: userId,
    company: primaryCompany?.Name ?? '',
    companyId: primaryCompany?.Id ?? '',
    userFunction: primaryRole?.Name ?? '',
    roles: user.Roles.map((r) => r.Name),
    isActive: user.IsActive,

    application: 'Soyuz',
    applicationName: 'Hybrid - Shiplex',
    departments: user.Departments.map((d) => d.Name),
    companies: user.Companies.map((c) => c.Name)
  };

  FullStory('setIdentity', { uid: userId, ...userProperties });
  FullStory('setProperties', { type: 'user', properties: userProperties });
  console.warn('[FullStory] User identified successfully');
}

export function anonymizeUser(): void {
  if (!isInitialized()) return;
  FullStory('setIdentity', { anonymous: true });
}
